/**
 * @overview higher order component to wrap components with a `user` and `refreshUser` prop
 */

import React from 'react'
import getDisplayName from 'lib/get-display-name'
import { Consumer } from './context'

export default function withUserContext(Component) {
  return class WithUserContext extends React.Component {
    static displayName = `WithUserContext(${getDisplayName(Component)})`

    render() {
      return (
        <Consumer>
          {({ refreshUser, user }) => (
            <Component refreshUser={refreshUser} user={user} {...this.props} />
          )}
        </Consumer>
      )
    }
  }
}
